import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ArrowRight } from 'lucide-react';
import { COLORS } from './landingData';

export function CtaFooter({ t }) {
  const navigate = useNavigate();

  return (
    <>
      {/* CTA Section */}
      <section style={{ padding: '80px 24px' }} data-testid="cta-section">
        <div style={{
          maxWidth: 700, margin: '0 auto', textAlign: 'center',
          background: COLORS.surface, borderRadius: 24, padding: '56px 40px',
          border: `1px solid ${COLORS.border}`,
          boxShadow: '0 4px 24px rgba(43,48,47,0.06)',
        }}>
          <h2 style={{ fontFamily: 'Outfit, sans-serif', fontSize: 'clamp(22px, 3vw, 32px)', fontWeight: 800, color: COLORS.text, marginBottom: 12 }}>
            {t.cta.title}
          </h2>
          <p style={{ fontSize: 15, color: COLORS.textSecondary, marginBottom: 28 }}>{t.cta.subtitle}</p>
          <Button
            size="lg"
            onClick={() => navigate('/login')}
            style={{ background: COLORS.secondary, color: '#fff', fontWeight: 700, padding: '14px 36px', fontSize: 16, borderRadius: 12 }}
            data-testid="cta-btn"
          >
            {t.cta.button} <ArrowRight style={{ width: 16, height: 16, marginLeft: 6 }} />
          </Button>
        </div>
      </section>

      {/* Footer */}
      <footer style={{ padding: '32px 24px', borderTop: `1px solid ${COLORS.border}` }} data-testid="landing-footer">
        <div style={{ maxWidth: 1100, margin: '0 auto', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 12 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <img src="/logo-final-e.svg" alt="PharmX" style={{ height: 24, width: 'auto', objectFit: 'contain' }} />
            <span style={{ fontSize: 13, color: COLORS.textMuted, marginLeft: 8 }}>{t.footer.tagline}</span>
          </div>
          <span style={{ fontSize: 12, color: COLORS.textMuted }}>{t.footer.copy}</span>
        </div>
      </footer>
    </>
  );
}
